import cn from "classnames";
import Image from "next/image";

import {Objects, useGameContext} from "@/context/GameContext";

const Sword = ({parentStyle,className, ...props}) => {

	const {isMobile} = useGameContext()

	return (
			<div className={cn(className)} {...props}>
				{/*Parchment*/}
				<Image className={cn(parentStyle.sword__image, 'sword__image')} src={'/images/Game/Sword/sword.png'} alt={"Sword"} id={Objects.SWORD} width={460} height={528}/>
				<Image className={parentStyle.sword__image_empty} src={'/images/Game/Sword/sword_empty.png'} alt={"Sword Empty"} width={460} height={528}/>

				{/*Sparkles*/}
				{isMobile !== undefined ? (isMobile ? <Image className={cn(parentStyle.sword__sparkles, 'sword__sparkles')} src={'/images/Game/Glow/sparkles.png'} alt={"Sparkles"} width={64} height={64}/>
						: <Image className={cn(parentStyle.sword__sparkles, 'sword__sparkles')} src={'/images/Game/Glow/sparkles.gif'} alt={"Sparkles"} width={64} height={64}/>) : null}
			</div>
	);
}
export default Sword;